import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import ModalDialog from '../modal-dialog/ModalDialog'
import {
    LIABILITY_STATEMENT_APPROVE_LABEL,
    LIABILITY_STATEMENT_DECLINE_LABEL,
    LIABILITY_STATEMENT_PARAGRAPHS,
    LIABILITY_STATEMENT_TITLE,
    LIABILITY_STATEMENT_WORDING_VERSION,
} from './liabilityStatement'

export default function LiabilityStatementDialog({
    open = false,
    detail = null,
    onApprove,
    onDecline,
}) {
    const approve = () => onApprove?.(LIABILITY_STATEMENT_WORDING_VERSION)
    const decline = () => onDecline?.(LIABILITY_STATEMENT_WORDING_VERSION)

    const commands = [
        {
            label: LIABILITY_STATEMENT_DECLINE_LABEL,
            testId: 'liability-statement-decline',
            color: 'secondary',
            onClick: decline,
        },
        {
            label: LIABILITY_STATEMENT_APPROVE_LABEL,
            testId: 'liability-statement-approve',
            position: 'end',
            onClick: approve,
        },
    ]

    return (
        <ModalDialog
            open={open}
            title={LIABILITY_STATEMENT_TITLE}
            commands={commands}
            onClose={decline}
        >
            <MDBox display="flex" flexDirection="column" gap="0.75rem">
                {LIABILITY_STATEMENT_PARAGRAPHS.map((paragraph) => (
                    <MDTypography key={paragraph} variant="body2">
                        {paragraph}
                    </MDTypography>
                ))}

                {detail?.value != null && (
                    <MDTypography variant="body2" fontWeight="medium">
                        {`הפרט המסומן: ${detail.value}`}
                    </MDTypography>
                )}
            </MDBox>
        </ModalDialog>
    )
}
